import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/theme.css'; // sistema de diseño propio (debe ir tras Bootstrap)
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ProfilePage from "./pages/ProfilePage";
import ProfileUserPageView from "./pages/ProfileUserPage";
import HomePage from "./pages/HomePage";
import ProjectsPage from "./pages/ProjectsPage";
import HomeNavBar from "./components/HomeNavBar";
import UsersPage from "./pages/UsersPage";
import ProjectPage from "./pages/ProjectPage";
import EventsPage from "./pages/EventsPage";
import MeetingsPage from "./pages/MeetingsPage";
import AdminPage from "./pages/AdminPage";
import ContactPage from "./pages/ContactPage";
import AnnouncementsPage from "./pages/AnnouncementsPage";
import { isSessionExpired, clearSession } from "./utils/Utils";

function App() {
  // Un token caducado es como no tener sesión: el backend lo va a rechazar
  // igual, así que mejor empezar en el login que a medio camino
  if (isSessionExpired()) clearSession();

  const token = localStorage.getItem("token");
  const isAdmin = localStorage.getItem("isAdmin") === "true";

  return React.createElement(
    BrowserRouter,
    null,
    // Navbar siempre visible
    token ? React.createElement(HomeNavBar) : null,
    React.createElement(
      Routes,
      null,
      React.createElement(
        Route,
        {
          path: "/",
          element: token
            ? React.createElement(Navigate, { to: "/home" })
            : React.createElement(LoginPage)
        }
      ),
      React.createElement(Route, { path: "/register", element: React.createElement(RegisterPage) }),
      React.createElement(
        Route,
        {
          path: "/profile",
          element: token
            ? React.createElement(ProfilePage)
            : React.createElement(Navigate, { to: "/" })
        }
      ),
      React.createElement(
        Route,
        {
          path: "/profile/:userId",
          element: token
            ? React.createElement(ProfileUserPageView)
            : React.createElement(Navigate, { to: "/" })
        }
      ),
      React.createElement(
        Route,
        {
          path: "/home",
          element: token
            ? React.createElement(HomePage)
            : React.createElement(Navigate, { to: "/" })
        }
      ),
      React.createElement(
        Route,
        {
          path: "/projects",
          element: token
            ? React.createElement(ProjectsPage)
            : React.createElement(Navigate, { to: "/" })
        }
      ),
      React.createElement(
        Route,
        {
          path: "/project/:id",
          element: token
            ? React.createElement(ProjectPage)
            : React.createElement(Navigate, { to: "/" })
        }
      ),
      React.createElement(
        Route,
        {
          path: "/networking",
          element: token
            ? React.createElement(UsersPage)
            : React.createElement(Navigate, { to: "/" })
        }
      ),
      React.createElement(
        Route,
        {
          path: "/events",
          element: token
            ? React.createElement(EventsPage)
            : React.createElement(Navigate, { to: "/" })
        }
      ),
      React.createElement(
        Route,
        {
          path: "/meetings",
          element: token
            ? React.createElement(MeetingsPage)
            : React.createElement(Navigate, { to: "/" })
        }
      ),
      /*
      React.createElement(
        Route,
        {
          path: "/announcements",
          element: token
            ? React.createElement(AnnouncementsPage)
            : React.createElement(Navigate, { to: "/" })
        }
      ),
      */
      React.createElement(
        Route,
        {
          path: "/admin",
          element: token && isAdmin
            ? React.createElement(AdminPage)
            : React.createElement(Navigate, { to: "/" })
        }
      ),

      React.createElement(
        Route,
        {
          path: "/admin/panel",
          element: token && isAdmin
            ? React.createElement(AdminPage)
            : React.createElement(Navigate, { to: "/" })
        }
      ),

      React.createElement(
        Route,
        {
          path: "/contact",
          element: token
            ? React.createElement(ContactPage)
            : React.createElement(Navigate, { to: "/" })
        }
      )
    )
  );
}


const root = createRoot(document.getElementById("root"));
root.render(React.createElement(App));
